export enum TipoHistoricoLead {
    CODIGO_ENVIO_EMAIL = 'ENVIO_EMAIL',
    CODIGO_ENVIO_WHATSAPP = 'ENVIO_WHATSAPP',
}